import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getPageRoute } from "src/services/Config.js";
import Footer from "../blocks/Footer.js";
import { motion } from "framer-motion";
import React from "react";

const StaggeredContent = ({ children }) => {
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.2,
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={container}
      style={{ position: "relative" }}
    >
      {React.Children.map(children, (child) => {
        const isSticky = child?.props?.["data-sticky"] === "true";

        return (
          <motion.div
            variants={item}
            style={{
              position: isSticky ? "sticky" : "static",
              top: isSticky ? 0 : undefined,
              zIndex: isSticky ? 1 : undefined,
              backgroundColor: isSticky ? "#fff" : undefined,
            }}
          >
            {child}
          </motion.div>
        );
      })}
    </motion.div>
  );
};

const InstructionsLayout = ({ children, nav = "back", sx }) => {
  const navigate = useNavigate();
  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <Box
        id="container"
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: "5% auto 0 auto",
          maxWidth: "400px",
          position: "relative",
          p: 2,
          px: 3.5,
          alignItems: "center",
          textAlign: "center",
          flex: 1,
          ...sx,
        }}
      >
        <Button
          variant="text"
          onClick={
            {
              back: () => navigate(-1),
              home: () => navigate(getPageRoute("home", "HOME")),
            }[nav]
          }
          sx={{ color: "text.secondary", mr: "auto", px: 0, mb: 3 }}
        >
          {{ back: "GO BACK", home: "GO HOME" }[nav]}
        </Button>

        <StaggeredContent>{children}</StaggeredContent>
      </Box>
      <Footer />
    </div>
  );
};

export default InstructionsLayout;
